export const INPUT_COMPONENT = "Input";
export const PHONE_INPUT_COMPONENT = "Phone Input";
export const SELECT_COMPONENT = "Select";
export const MULTI_SELECT_COMPONENT = "Multi Select";
export const AUTO_COMPLETE_COMPONENT = "Autocomplete";
export const DATE_COMPONENT = "Date";
export const SWITCH_COMPONENT = "Switch";
